import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ab62db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "maxlength", "value", "placeholder", "autofocus", "spellcheck"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_icon = _resolveComponent("t-icon")!

  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    class: _ctx.getClasses.wrap,
    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    (_ctx.$slots.prefix || _ctx.prefix)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.getClasses.prefix)
        }, [
          _renderSlot(_ctx.$slots, "prefix", {}, () => [
            (_ctx.prefix)
              ? (_openBlock(), _createBlock(_component_t_icon, {
                  key: 0,
                  "icon-name": _ctx.prefix,
                  size: "small"
                }, null, 8, ["icon-name"]))
              : _createCommentVNode("", true)
          ], true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({ ref: "input" }, _ctx.$attrs, {
      type: _ctx.inputType,
      maxlength: _ctx.maxlength,
      value: _ctx.myInputValue,
      placeholder: _ctx.placeholder,
      class: _ctx.getClasses.inputControl,
      autofocus: _ctx.autofocus,
      spellcheck: _ctx.spellcheck,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInputHandler && _ctx.onInputHandler(...args))),
      onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocusHandler && _ctx.onFocusHandler(...args))),
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlurHandler && _ctx.onBlurHandler(...args))),
      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeHandler && _ctx.onChangeHandler(...args)))
    }), null, 16, _hoisted_1),
    (_ctx.$slots.suffix || _ctx.suffix)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.getClasses.suffix)
        }, [
          _renderSlot(_ctx.$slots, "suffix", {}, () => [
            (_ctx.suffix)
              ? (_openBlock(), _createBlock(_component_t_icon, {
                  key: 0,
                  "icon-name": _ctx.suffix,
                  size: "small"
                }, null, 8, ["icon-name"]))
              : _createCommentVNode("", true)
          ], true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.tips || _ctx.tips)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.getClasses.footer)
        }, [
          _renderSlot(_ctx.$slots, "tips", {}, () => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.getClasses.tips)
            }, _toDisplayString(_ctx.tips), 3)
          ], true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.hasBorder && _ctx.getFormItemName !== 'TFormItem')
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(_ctx.getClasses.border)
        }, null, 2))
      : _createCommentVNode("", true)
  ], 16))
}